var REQUEST = 'network/REQUEST';
var REQUEST_START = 'network/REQUEST/start';
var REQUEST_SUCCESS = 'network/REQUEST/success';
var REQUEST_ERROR = 'network/REQUEST/error';
var SET_SCOPE = 'network/SET_SCOPE';
var GET_TOKEN = 'network/GET_TOKEN';
var GET_TOKEN_START = 'network/GET_TOKEN/start';
var GET_TOKEN_SUCCESS = 'network/GET_TOKEN/success';
var GET_TOKEN_ERROR = 'network/GET_TOKEN/error';
var REFRESH_TOKEN = 'network/REFRESH_TOKEN';
var REFRESH_TOKEN_START = 'network/REFRESH_TOKEN/start';
var REFRESH_TOKEN_SUCCESS = 'network/REFRESH_TOKEN/success';
var REFRESH_TOKEN_ERROR = 'network/REFRESH_TOKEN/error';
var STORE_TOKENS = 'network/STORE_TOKENS';
var STORE_TOKENS_START = 'network/STORE_TOKENS/start';
var STORE_TOKENS_SUCCESS = 'network/STORE_TOKENS/success';
var STORE_TOKENS_ERROR = 'network/STORE_TOKENS/error';
var REMOVE_TOKENS = 'network/REMOVE_TOKENS';
var REMOVE_TOKENS_START = 'network/REMOVE_TOKENS/start';
var REMOVE_TOKENS_SUCCESS = 'network/REMOVE_TOKENS/success';
var REMOVE_TOKENS_ERROR = 'network/REMOVE_TOKENS/error';

export { GET_TOKEN, GET_TOKEN_ERROR, GET_TOKEN_START, GET_TOKEN_SUCCESS, REFRESH_TOKEN, REFRESH_TOKEN_ERROR, REFRESH_TOKEN_START, REFRESH_TOKEN_SUCCESS, REMOVE_TOKENS, REMOVE_TOKENS_ERROR, REMOVE_TOKENS_START, REMOVE_TOKENS_SUCCESS, REQUEST, REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS, SET_SCOPE, STORE_TOKENS, STORE_TOKENS_ERROR, STORE_TOKENS_START, STORE_TOKENS_SUCCESS };
//# sourceMappingURL=actionTypes.js.map
